import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, Route, Switch, Redirect } from "react-router-dom";

import { fetchAreaPartners } from "../actions/acLanding";
import { getBlogPosts, simpleFetch } from "../actions/acCommon";

import LandingNav from "./LandingNav";
import { PootsyButton, PootsyTitle } from "./DesignFunctions";
import { PootsyTextInput } from "./InputsFunctions";
import LandingCustomerContent from "./LandingCustomerContent";
import LandingAffiliateContent from "./LandingAffiliateContent";
import SimpleOverlay from "./SimpleOverlay";
import Footer from "./Footer";

import * as bookingFlowActions from "../actions/acBookingFlow";

import pootsyLogo from "../static/img/pootsy-logo.png";
import checkmarkIcon from "../static/img/checkmark.png";

class Landing extends Component {
  state = {
    email: "",
    showVidOverlay: false,
    checkZipCodeMode: false,
    showEmailSentFlash: false
  };

  componentWillMount = () => {
    let { t } = this.context;
    let {
      dispatch,
      match: { params }
    } = this.props;
    if (params.area && params.zone_name) {
      this.setState({ checkZipCodeMode: true });
      document.title = t("zip_code_mode_page_title", {
        area: params.area,
        zoneName: params.zone_name
      });
      let metaTag = document.querySelector('meta[name="description"]');
      metaTag.setAttribute(
        "content",
        t("zip_code_mode_meta_description", {
          area: params.area,
          zoneName: params.zone_name
        })
      );
      dispatch(fetchAreaPartners(params.area));
    }
  };

  componentWillReceiveProps = newProps => {
    let {
      lang,
      match: { params }
    } = newProps;
    if (this.props.lang !== lang) {
      this.props.dispatch(getBlogPosts());
    }
    if (!(params.area && params.zone_name)) {
      this.setState({ checkZipCodeMode: false });
    }
  };

  componentDidMount = () => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
    this.props.dispatch(getBlogPosts());
  };

  toggleVideo = () => {
    this.setState(state => ({ showVidOverlay: !state.showVidOverlay }));
  };

  handleEmailChange = e => {
    e.stopPropagation();
    this.setState({ email: e.target.value });
  };

  sendEmail = () => {
    let {
      dispatch,
      match: { params }
    } = this.props;
    let { email } = this.state;
    let init = {
      method: "POST",
      body: JSON.stringify({ email: email, zip_code: params.area })
    };
    let url = "/public/ask_for_zip_code";
    dispatch(simpleFetch(url, init, "SUBMIT_ASK_FOR_ZIP_CODE")).then(
      response => {
        if (response.actionType === "SUBMIT_ASK_FOR_ZIP_CODE_SUCCESS") {
          this.flashEmailSent();
        }
      }
    );
  };

  flashEmailSent = () => {
    this.setState({ showEmailSentFlash: true });
    setTimeout(() => {
      this.setState({ showEmailSentFlash: false });
    }, 1500);
  };

  displayFallbackLogo = e => {
    e.target.src = pootsyLogo;
  };

  render() {
    let { t } = this.context;
    let { zipCodeURLs, match, location, landing, lang, auth } = this.props;
    let {
      checkZipCodeMode,
      showVidOverlay,
      email,
      showEmailSentFlash
    } = this.state;
    let landingContent =
      location.pathname === "/" ? landing.affiliate : landing.customer;
    let isSignedIn = auth.tokenChecked && auth.signedIn;
    if (checkZipCodeMode) {
      landingContent = landing.checkZipCodeMode;
    }

    landing.customer.heroButtons = [
      <Link key="a" to="/booking-flow" onClick={this.startBookingFlow}>
        <PootsyButton text={t("customer_find_cleaner")} />
      </Link>,
      <PootsyButton
        key="b"
        text={t("see_video")}
        theme="hollow"
        onClick={this.toggleVideo}
      />
    ];
    landing.customer.navLinks = [
      <Link key="a" to="/">
        {t("become_partner")}
      </Link>,
      <a
        rel="noreferrer noopener"
        href="https://www.linkedin.com/company/pootsy"
        target="_blank"
      >
        {t("blog")}
      </a>,
      <Link key="b" to={isSignedIn ? "/app" : "/auth/signin"}>
        <PootsyButton
          key="c"
          text={isSignedIn ? t("my_account") : t("login")}
        />
      </Link>
    ];

    landing.checkZipCodeMode.heroButtons = landing.customer.heroButtons;
    landing.checkZipCodeMode.navLinks = landing.customer.navLinks;
    landing.checkZipCodeMode.heroTitle = match.params.zone_name;
    landing.checkZipCodeMode.heroPrompt = landing.zipCodeInfo.covered
      ? "pootsy_covers_area_desc"
      : "pootsy_does_not_cover_area_desc";
    landing.checkZipCodeMode.heroButtons = [
      <div key="c" className="underlined-links">
        <a className="underline-link" href="#features">
          {t("more_about_pootsy")}
        </a>
        <a className="underline-link" href="#how">
          {t("more_about_service_vouchers")}
        </a>
      </div>
    ];
    if (checkZipCodeMode && landing.zipCodeInfo.covered) {
      landing.checkZipCodeMode.heroButtons.unshift(
        <Link key="a" to="/booking-flow" onClick={this.startBookingFlow}>
          <PootsyButton
            text={t("find_my_cleaner_in_area") + " " + match.params.zone_name}
          />
        </Link>,
        <PootsyButton
          key="b"
          text={t("see_video")}
          theme="hollow"
          onClick={this.toggleVideo}
        />
      );
    }

    landing.affiliate.heroButtons = [
      <PootsyButton
        key="a"
        text={
          <a
            href={`mailto:demo@pootsy.be?subject=${t(
              "ask_for_demo_mail_subject"
            )}&body=${encodeURI(t("ask_for_demo_mail_content"))}`}
          >
            {t("ask_for_affiliate_demo")}
          </a>
        }
      />,
      <PootsyButton
        key="b"
        text={t("see_video")}
        theme="hollow"
        onClick={this.toggleVideo}
      />
    ];
    landing.affiliate.navLinks = [
      <Link key="a" to="/customer">
        {t("im_a_customer")}
      </Link>,
      <a
        rel="noreferrer noopener"
        href="https://www.linkedin.com/company/pootsy"
        target="_blank"
      >
        {t("blog")}
      </a>,
      <Link key="c" to={isSignedIn ? "/app" : "/auth/signin"}>
        <PootsyButton
          key="c"
          text={isSignedIn ? t("my_account") : t("login")}
        />
      </Link>
    ];
    return (
      <div className="landing-wrapper">
        <div
          className={"email-sent-flash" + (showEmailSentFlash ? " active" : "")}
        >
          <img alt="checkmark-icon" src={checkmarkIcon} />
          {t("thank_you_email_sent_flash")}
        </div>
        {landingContent.shapeBackground}
        <div className="Landing">
          <LandingNav links={landingContent.navLinks} />
          <section className="landing-top">
            <div className="content">
              <div className="hero">
                {checkZipCodeMode && (
                  <div className="zip-code-mode-desc">
                    {landing.zipCodeInfo.covered
                      ? t("pootsy_covers_area_at")
                      : t("pootsy_does_not_cover_area_at")}
                  </div>
                )}
                <PootsyTitle
                  title={t(landingContent.heroTitle)}
                  customClass={checkZipCodeMode ? " zip-code-mode" : ""}
                />
                <div className="prompt">{t(landingContent.heroPrompt)}</div>
                {checkZipCodeMode && !landing.zipCodeInfo.covered && (
                  <div className="send-us-email">
                    <PootsyTextInput
                      name="email"
                      label={t("email_input_label")}
                      value={email}
                      onChange={this.handleEmailChange}
                    />
                    <PootsyButton text={t("send")} onClick={this.sendEmail} />
                  </div>
                )}
                <div className="buttons">{landingContent.heroButtons}</div>
              </div>
              {landingContent.heroBackground}
            </div>
          </section>
          {showVidOverlay && (
            <SimpleOverlay toggleOverlay={this.toggleVideo}>
              <iframe
                title="vid"
                type="text/html"
                src={t("video_url")}
                frameBorder="0"
                allowFullScreen
              />
            </SimpleOverlay>
          )}
          {checkZipCodeMode && landing.zipCodeInfo.covered && (
            <div className="area-partners">
              <div className="discover-our-partners">
                {t("discover_our_partners_in")}{" "}
                <span className="zone">{match.params.zone_name}</span>
              </div>
              {landing.zipCodeInfo.affiliates.map(affiliate => (
                <div key={affiliate.id} className="area-partner">
                  <div className="logo">
                    <img
                      alt="logo"
                      src={affiliate.logo.medium.url}
                      onError={this.displayFallbackLogo}
                    />
                  </div>
                  <div className="separator" />
                  <div className="name">
                    {affiliate.name}
                    <Link
                      to={
                        "/" +
                        affiliate.id +
                        "-" +
                        affiliate.name.replace(" ", "-")
                      }
                    >
                      <PootsyButton
                        text={t("see_our_availabilities")}
                        dataset={{ "data-id": affiliate.id }}
                      />
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          )}
          <div className="features" id="features">
            {landingContent.features.map((feature, index, arr) => {
              let el = [
                <div key={feature.title} className="feature">
                  <div className="feature-icon">{feature.img}</div>
                  <div className="feature-title">{t(feature.title)}</div>
                  <div className="feature-desc">{t(feature.desc)}</div>
                </div>
              ];
              if (index < arr.length - 1) {
                el.push(
                  <div key={feature.title + "sep"} className="separator"></div>
                );
              }
              return el;
            })}
          </div>
          <Switch>
            <Route
              exact
              path="/customer"
              render={props => (
                <LandingCustomerContent
                  {...props}
                  lang={lang}
                  posts={landing.posts}
                />
              )}
            />
            <Route
              path="/"
              component={() => <LandingAffiliateContent lang={lang} />}
            />
            {zipCodeURLs.map(url => (
              <Route
                key={url}
                path={url}
                render={props => (
                  <LandingCustomerContent
                    {...props}
                    lang={lang}
                    posts={landing.posts}
                  />
                )}
              />
            ))}
            <Route
              path="/"
              component={props => (
                <LandingAffiliateContent {...props} lang={lang} />
              )}
            />
            <Redirect to="/" />
          </Switch>
        </div>
        <Footer lang={lang} />
      </div>
    );
  }

  startBookingFlow = () => {
    this.props.dispatch(bookingFlowActions.startBookingFlow());
  };
}

Landing.contextTypes = { t: PropTypes.func };
const mapStateToProps = state => ({
  landing: state.dataReducer.landing,
  lang: state.i18nState.lang,
  auth: state.metadataReducer.auth
});
export default connect(mapStateToProps)(Landing);



// WEBPACK FOOTER //
// ./src/components/Landing.js